import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=b1a396ea&scoped=true&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=b1a396ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a396ea",
  null
  
)

export default component.exports